module.exports = __webpack_public_path__ + "media/belive.ceb236ff.wav";